import axios from 'axios';

export const downloadOrdenFile = async (id: number, fileName: string, event: any) => {
    event.preventDefault();
    event.stopPropagation();
    let data;
    await axios({
        url: `${process.env.REACT_APP_API}forma/pago/ordenes/cobro/pdf/download/${id}`,
        method: 'GET',
        responseType: 'blob',
    })
    .then((response) => {
        data = response;
        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlBlob;
        link.setAttribute('download', `${fileName}.pdf`);
        link.click();
        window.URL.revokeObjectURL(urlBlob);
    })
    .catch(async (error) => {
        data = JSON.parse(await error.response.data.text());
    });
    return data;
};

export const previewOrdenFile = async (id: number) => {
    let responseData;
    try {
    const response = await axios.get(`${process.env.REACT_APP_API}forma/pago/ordenes/cobro/pdf/view/${id}`, {
        responseType: 'blob'
    });
    responseData = response.data;
    } catch (error) {
    console.error('Error fetching PDF:', error);
    }
    return responseData;
};
